import { Alert, Button, Empty, Pagination, Space, Table, Typography } from "antd"
import { useState } from "react"
import { Link } from "react-router-dom"
import type { PhysicalKind, PhysicalInspection } from "../../types/physical"
import { usePhysicalResource } from "../../components/physical/usePhysicalResource"
import { physicalApi, physicalError } from "../../utils/physicalApi"
export function PhysicalHistory({ kind, id }: { kind: PhysicalKind; id: string }) {
  const [page, setPage] = useState(1)
  const resource = usePhysicalResource(`history/${kind}/${id}/${page}`, (signal) =>
    physicalApi.inspections(kind, id, { limit: 20, offset: (page - 1) * 20 }, signal),
  )
  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Typography.Paragraph type="secondary">
        Les noms, adresses et dates ci-dessous sont ceux enregistrés dans chaque inspection.
      </Typography.Paragraph>
      {resource.error && (
        <Alert
          type="error"
          message={physicalError(resource.error)}
          action={<Button onClick={resource.reload}>Réessayer</Button>}
        />
      )}
      <Table<PhysicalInspection>
        loading={resource.loading}
        dataSource={resource.data?.items ?? []}
        rowKey={(r) => `${r.uuid}/${r.equipmentUuid ?? ""}/${r.contextUuid ?? ""}`}
        pagination={false}
        scroll={{ x: 650 }}
        locale={{
          emptyText: (
            <Empty description="Aucune inspection rattachée. Ouvrez une inspection existante pour la rattacher à ce dossier." />
          ),
        }}
        columns={[
          {
            title: "Date",
            key: "date",
            render: (_, r) =>
              r.executionDate
                ? r.executionDate.slice(0, 10).split("-").reverse().join("/")
                : "Non renseignée",
          },
          {
            title: "Inspection",
            key: "mission",
            render: (_, r) => (
              <Link to={`/sites/${r.uuid}`}>
                {r.missionName || r.siteName || "Inspection sans titre"}
              </Link>
            ),
          },
          { title: "Site à la date de l’inspection", dataIndex: "siteName" },
          ...(kind !== "site"
            ? [
                {
                  title: "Équipement inspecté",
                  key: "equipment",
                  render: (_: unknown, r: PhysicalInspection) =>
                    r.equipmentUuid ? (
                      <Link to={`/equipments/${r.equipmentUuid}`}>
                        {r.equipmentName || "Équipement"}
                      </Link>
                    ) : (
                      "—"
                    ),
                },
              ]
            : []),
          { title: "Adresse enregistrée", dataIndex: "address" },
        ]}
      />
      <Pagination
        current={page}
        total={resource.data?.total ?? 0}
        pageSize={20}
        showSizeChanger={false}
        onChange={setPage}
        showTotal={(n) => `${n} inspections`}
      />
    </Space>
  )
}
